if (!customElements.get('nrx-product-list')) {
    class NRXProductList extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                active: 'active',
                slider: 'swiper',
                list: 'swiper-wrapper',
                item: 'swiper-slide',
                navigation: {
                    nav: 'js-nrx-swiper-nav',
                    prev: 'js-nrx-swiper-prev',
                    next: 'js-nrx-swiper-next',
                    pagination: 'js-nrx-swiper-pagination'
                }
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.slider}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                navigation: {
                    nav: this.querySelector(`.${this.classes.navigation.nav}`),
                    prev: this.querySelector(`.${this.classes.navigation.prev}`),
                    next: this.querySelector(`.${this.classes.navigation.next}`),
                    pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
                }
            };

            this.resizeHandler = this.handleResize.bind(this);
        }

        /**
         * Initialize when element is added to DOM
         */
        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        /**
         * Clean up when element is removed from DOM
         */
        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy();
            }
            window.removeEventListener('resize', this.resizeHandler);
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        /**
         * Check if the list is empty
         * @returns {boolean}
         */
        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        /**
         * Initialize the swiper
         */
        init() {
            const shouldInit = this.shouldInitialize();
            this.toggleNavigation(shouldInit);
            if (!shouldInit) return;
            this.initializeSwiper();
        }

        /**
         * Check if the swiper should be initialized
         * @returns {boolean}
         */
        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;

            const width = window.innerWidth;
            const slidesCount = this.elements.items.length;

            if (width < 768 && slidesCount <= 1) return false;
            if (width >= 768 && width < 1199 && slidesCount <= 3) return false;
            if (width >= 1200 && slidesCount <= 4) return false;

            return true;
        }

        /**
         * Handle the resize event
         */
        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();
                this.toggleNavigation(shouldInit);

                if (shouldInit && !this.swiper) {
                    this.initializeSwiper();
                } else if (!shouldInit && this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }, 300);
        }


        /**
         * Navigation visibility
        */

        toggleNavigation(show) {
            if (!this.elements.navigation.nav) return;

            this.elements.navigation.nav.style.display = show ? '' : 'none';
        }

        /**
         * Initialize the swiper
         */

        initializeSwiper() {
            this.swiper = new Swiper(this.elements.slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                watchOverflow: true,
                navigation: {
                    prevEl: this.elements.navigation.prev,
                    nextEl: this.elements.navigation.next,
                },
                pagination: {
                    el: this.elements.navigation.pagination,
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    1024: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        spaceBetween: 24
                    }
                }
            });
        }
    }

    customElements.define('nrx-product-list', NRXProductList);
}